export const NAVBAR_HEIGHT = '50px'
export const INPUT_HEIGHT = '40px'
export const BUTTON_HEIGHT = '30px'
export const BORDER_RADIUS = '3px'
export const BIG_SEPARATOR = '40px'
